import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Box, Flex } from 'reflexbox'
import {
    Button,
    ButtonGroup,
    Classes,
    Dialog,
    FormGroup,
    Icon,
    InputGroup,
    MenuItem,
    Spinner,
} from '@blueprintjs/core'

import DocumentationCard from './DocumentationCard'
import InputSelect from 'src/components/InputSelect'
import {
    getCustomerById,
    searchCustomer,
} from 'src/store/modules/cmdb/customers'
import * as solutionModules from 'src/store/modules/cmdb/solutions'
import * as deviceModules from 'src/store/modules/cmdb/devices'
import * as documentationModules from 'src/store/modules/cmdb/documentation'

const errorForField = (errors, field) =>
    errors[field] && errors[field].join(', ')

class Documentation extends React.Component {
    state = {
        customer: '',
        solution: '',
        link: '',
        errors: {},
        disabled: true,
        filteredSolution: '',
        filteredMode: '',
        filteredParameter: '',
    }

    componentDidMount() {
        this.props.actions.getDocumentations()
        this.props.actions.getZonesOfCustomer()
        this.props.actions.getCustomer()
        this.props.actions.selectCustomer()
    }

    handleFieldChange = (field) => (e) => {
        this.setState({
            [field]: e.target.value,
        })
    }

    handleDocumentationSave = () => {
        const { solution, link } = this.state
        const data = { customer: this.props.selectedCustomer, solution, link }
        let docId = null
        if (this.props.documentation) {
            docId = this.props.documentation.id
        }
        this.props.actions.saveDocumentation(docId, data)
    }

    handleNewDocumentationModalClose = () => {
        this.props.actions.closeNewDocumentationModal()
    }

    handleEditDocumentationModalClose = () => {
        this.props.actions.closeEditDocumentationModal()
    }

    solutionRenderer = (item, { handleClick, modifiers }) => {
        return (
            <MenuItem
                active={modifiers.active}
                key={item.id}
                onClick={handleClick}
                text={item.id}
                label={item.name}
            />
        )
    }

    renderInputValue = (solution) => solution['solution']

    renderEditDialog() {
        const { solution, link } = this.state
        const { errors, solutionsLoading, solutionResults } = this.props

        return (
            <Dialog
                isOpen={true}
                onClose={this.handleEditDocumentationModalClose}
                title="Edit Entry"
            >
                <div className={Classes.DIALOG_BODY}>
                    <FormGroup
                        label="Solution name / CI"
                        helperText={errorForField(errors, 'solution')}
                        intent={errorForField(errors, 'solution') && 'danger'}
                    >
                        <InputSelect
                            inputProps={{
                                placeholder: 'Solution name',
                                large: true,
                                rightElement: solutionsLoading ? (
                                    <Spinner size={Icon.SIZE_STANDARD} />
                                ) : null,
                            }}
                            openOnKeyDown={false}
                            onQueryChange={(value) => {
                                this.setState({ solution: value })
                                this.props.actions.searchCmdbSolutions(value)
                            }}
                            selectedItem={{ solution: solution }}
                            items={solutionResults}
                            itemRenderer={this.solutionRenderer}
                            inputValueRenderer={this.renderInputValue}
                            onItemSelect={(value) =>
                                this.setState({ solution: value.id || '' })
                            }
                            noResults={
                                <MenuItem disabled={true} text="No results." />
                            }
                            popoverProps={{
                                minimal: true,
                                targetClassName: 'full-width',
                            }}
                        />
                    </FormGroup>
                    <FormGroup
                        label="Documentation link"
                        helperText={errorForField(errors, 'link')}
                        intent={errorForField(errors, 'link') && 'danger'}
                    >
                        <InputGroup
                            value={link}
                            onChange={this.handleFieldChange('link')}
                            fill
                            placeholder=""
                        />
                    </FormGroup>
                </div>

                <div className={Classes.DIALOG_FOOTER}>
                    <Flex>
                        <Box w={1 / 2}>
                            <Button onClick={this.handleDocumentationSave}>
                                Save
                            </Button>
                        </Box>
                        <Box style={{ textAlign: 'right' }} w={1 / 2}>
                            <Button
                                onClick={this.handleEditDocumentationModalClose}
                            >
                                Cancel
                            </Button>
                        </Box>
                    </Flex>
                </div>
            </Dialog>
        )
    }

    renderAddNewDialog() {
        const { solution, link } = this.state
        const { errors, solutionsLoading, solutionResults } = this.props

        return (
            <Dialog
                isOpen={true}
                onClose={this.handleNewDocumentationModalClose}
                title="New Entry"
            >
                <div className={Classes.DIALOG_BODY}>
                    <FormGroup
                        label="Solution name / CI"
                        helperText={errorForField(errors, 'solution')}
                        intent={errorForField(errors, 'solution') && 'danger'}
                    >
                        <InputSelect
                            inputProps={{
                                placeholder: 'Solution name',
                                large: true,
                                rightElement: solutionsLoading ? (
                                    <Spinner size={Icon.SIZE_STANDARD} />
                                ) : null,
                            }}
                            openOnKeyDown={false}
                            onQueryChange={(value) => {
                                this.setState({ solution: value })
                                this.props.actions.searchCmdbSolutions(value)
                            }}
                            selectedItem={{ solution: solution }}
                            items={solutionResults}
                            itemRenderer={this.solutionRenderer}
                            inputValueRenderer={this.renderInputValue}
                            onItemSelect={(value) =>
                                this.setState({ solution: value.id || '' })
                            }
                            noResults={
                                <MenuItem disabled={true} text="No results." />
                            }
                            popoverProps={{
                                minimal: true,
                                targetClassName: 'full-width',
                            }}
                        />
                    </FormGroup>
                    <FormGroup
                        label="Documentation link"
                        helperText={errorForField(errors, 'link')}
                        intent={errorForField(errors, 'link') && 'danger'}
                    >
                        <InputGroup
                            value={link}
                            onChange={this.handleFieldChange('link')}
                            fill
                            placeholder=""
                        />
                    </FormGroup>
                </div>

                <div className={Classes.DIALOG_FOOTER}>
                    <Flex>
                        <Box w={1 / 2}>
                            <Button onClick={this.handleDocumentationSave}>
                                Save
                            </Button>
                        </Box>
                        <Box style={{ textAlign: 'right' }} w={1 / 2}>
                            <Button
                                onClick={this.handleNewDocumentationModalClose}
                            >
                                Cancel
                            </Button>
                        </Box>
                    </Flex>
                </div>
            </Dialog>
        )
    }

    renderFilterRow() {
        const { documentations } = this.props

        if (documentations.length === 0) {
            return null
        }

        return (
            <Box w={1} p={1}>
                <Flex w={1}>
                    <Box w={1 / 3} p={1}>
                        <InputGroup
                            large={true}
                            leftIcon="filter"
                            onChange={this.handleFieldChange(
                                'filteredSolution'
                            )}
                            placeholder="Filter by solution name"
                        />
                    </Box>

                    <Box w={1 / 3} p={1}>
                        <InputGroup
                            large={true}
                            leftIcon="filter"
                            onChange={this.handleFieldChange('filteredMode')}
                            placeholder="Filter by DR type"
                        />
                    </Box>

                    <Box w={1 / 3} p={1}>
                        <InputGroup
                            large={true}
                            leftIcon="filter"
                            onChange={this.handleFieldChange(
                                'filteredParameter'
                            )}
                            placeholder="Filter by parameter"
                        />
                    </Box>
                </Flex>
            </Box>
        )
    }

    renderCustomerInput() {
        const { openNewDocumentationModal } = this.props.actions

        return (
            <ButtonGroup>
                {/*<Box w={1} p={1} style={{ display: 'flex', marginLeft: '10px' }}>*/}
                {/*    <CustomerSelect*/}
                {/*        selected={selectedCustomer}*/}
                {/*        onCustomerSelect={this.handleCustomerSelect}*/}
                {/*    />*/}
                {/*</Box>*/}
                <Box
                    w={1}
                    p={1}
                    style={{ display: 'flex', marginLeft: '10px' }}
                >
                    <Button
                        text="New Entry"
                        icon="plus"
                        onClick={() => openNewDocumentationModal()}
                        large={false}
                    />
                </Box>
            </ButtonGroup>
        )
    }

    renderDocumentationCards() {
        const { documentations, documentationsLoading } = this.props

        const { filteredSolution, filteredMode, filteredParameter } = this.state

        if (documentationsLoading) {
            return <Spinner />
        }
        if (documentations.length === 0) {
            return null
        }

        const filterDocumentations = (doc) => {
            if (filteredSolution) {
                if (
                    doc.solution
                        .toLowerCase()
                        .indexOf(filteredSolution.toLowerCase()) < 0
                ) {
                    return false
                }
            }

            if (filteredMode) {
                if (
                    doc.mode.toLowerCase().indexOf(filteredMode.toLowerCase()) <
                    0
                ) {
                    return false
                }
            }

            if (filteredParameter) {
                if (
                    doc.parameter
                        .toLowerCase()
                        .indexOf(filteredParameter.toLowerCase()) < 0
                ) {
                    return false
                }
            }

            return true
        }

        return documentations
            .filter(filterDocumentations)
            .map((documentation) => (
                <DocumentationCard
                    documentation={documentation.id}
                    key={documentation.id}
                />
            ))
    }

    render() {
        const {
            modalNewDocumentationOpen,
            modalEditDocumentationOpen,
        } = this.props
        return (
            <Flex wrap w={1}>
                {this.renderCustomerInput()}
                {modalNewDocumentationOpen && this.renderAddNewDialog()}
                {modalEditDocumentationOpen && this.renderEditDialog()}
                {/*{this.renderFilterRow()}*/}
                {this.renderDocumentationCards()}
            </Flex>
        )
    }
}

Documentation.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
    }),
}

const mapStateToProps = (state) => {
    return {
        selectedCustomer: getCustomerById(
            state,
            state.cmdb.solutions.selectedCustomer
        ),
        solutionsLoading: state.cmdb.solutions.loading,

        solutionResults: deviceModules.getDeviceResults(state),

        documentation: documentationModules.getDocumentationById(
            state,
            state.cmdb.documentation.id
        ),
        documentations: documentationModules.getDocumentations(state),
        documentationsLoading: state.cmdb.documentation.loading,

        modalNewDocumentationOpen:
            state.cmdb.documentation.modalNewDocumentationOpen,
        modalEditDocumentationOpen:
            state.cmdb.documentation.modalEditDocumentationOpen,
        availability_zones: state.cmdb.documentation.availability_zones,
        main_availability_zones:
            state.cmdb.documentation.main_availability_zones,

        errors: state.cmdb.documentation.errors,
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        dispatch,
        actions: bindActionCreators(
            {
                selectCustomer: () =>
                    solutionModules.selectCmdbSolutionCustomer(
                        ownProps.match.params.id
                    ),
                searchCmdbSolutions: (solution) =>
                    deviceModules.searchDevices(
                        solution,
                        ownProps.match.params.id
                    ),
                getDocumentations: () =>
                    documentationModules.getDocumentationsFromServer(
                        ownProps.match.params.id
                    ),
                getZonesOfCustomer: () =>
                    documentationModules.getZonesOfCustomer(
                        ownProps.match.params.id
                    ),
                getCustomer: () => searchCustomer(ownProps.match.params.id),
                saveDocumentation: documentationModules.saveDocumentation,
                openNewDocumentationModal:
                    documentationModules.openNewDocumentationModal,
                closeNewDocumentationModal:
                    documentationModules.closeNewDocumentationModal,

                closeEditDocumentationModal:
                    documentationModules.closeEditDocumentationModal,
            },
            dispatch
        ),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Documentation)
